import { LocalLookupService } from "./core/LocalLookupService";
import { QualificationReferencesServiceSearch } from "./business/QualificationReferencesServiceSearch";
import { QualificationReferencesService } from "./business/QualificationReferencesService";
import { AwardingOrganisationsServiceSearch } from "./business/AwardingOrganisationServiceSearch";
import { AwardingOrganisationsService } from "./business/AwardingOrganisationsService";
import { QualificationTypesService } from "./business/QualificationTypesService";
import { CasesService } from "./business/CasesService";
import config from "../config";
import { ActivitiesService } from "./business/ActivitiesService";
import { userAuthService } from "../auth/UserAuthService";
import { UsersService } from "./business/UsersService";
import { TeamsService } from "./business/TeamsService";
import { RiskTypesService } from "./business/RiskTypesService";
import { GeneralConditionsService } from "./business/GeneralConditionsService";
import { ExamSeriesService } from "./business/ExamSeriesService";
import { ExamSeriesYearsService } from "./business/ExamSeriesYearsService";
import { QualificationConditionsService } from "./business/QualificationConditionsService";
import { SubjectConditionsService } from "./business/SubjectConditionsService";
import { CachingService } from "./core/CachingService";
import { RolesService } from "./business/RolesService";
import { EmailService } from "./business/EmailService";
import { ExceptionalCircumstanceService } from "./business/ExceptionalCircumstancesService";
import { TagsService } from "./business/TagsService";
import { ResourceTagsService } from "./business/ResourceTagsService";
const { API_ROOT, API_ROOT_USERS, API_ROOT_SEARCH, API_ROOT_REFDATA, DEFAULT_PAGE_SIZE, API_ROOT_ORGS, API_ROOT_SVR, } = config;
export const PAGE_SIZE = DEFAULT_PAGE_SIZE;
export * from "./core/types";
export const titlesService = new LocalLookupService("titles");
export const sourcesService = new LocalLookupService("sources");
export const complaintTypesService = new LocalLookupService("complaintTypes");
export const complaintStatusService = new LocalLookupService("complaintStatus");
export const stagesService = new LocalLookupService("stages");
export const activityNoteTypesService = new LocalLookupService("activityNoteTypes");
export const activityDocumentTypesService = new LocalLookupService("activityDocumentTypes");
export const natureOfComplaintService = new LocalLookupService("natureOfComplaint");
export const subNatureOfComplaintService = new LocalLookupService("subNatureOfComplaint");
export const natureOfAllegationService = new LocalLookupService("natureOfAllegation");
export const subNatureOfAllegationService = new LocalLookupService("subNatureOfAllegation");
export const complaintOutcomeService = new LocalLookupService("complaintOutcome");
export const regulatoryActionTakenService = new LocalLookupService("regulatoryActionTaken");
export const sourceOfAllegationService = new LocalLookupService("sourceOfAllegation");
export const finalDeterminationService = new LocalLookupService("finalDetermination");
export const actionsArisingService = new LocalLookupService("actionsArising");
export const disclosureActionsTakenService = new LocalLookupService("disclosureActionsTaken");
export const aoActionsService = new LocalLookupService("aoActions");
export const activityCommsTypesService = new LocalLookupService("activityCommsTypes");
export const peopleAffectedService = new LocalLookupService("peopleAffected");
export const internalReviewOutcomesService = new LocalLookupService("internalReviewOutcomes");
export const internalReviewActionsService = new LocalLookupService("internalReviewActions");
export const internalReviewReasonsService = new LocalLookupService("internalReviewReasons");
export const aoComplaintService = new LocalLookupService("aoComplaint");
export const relationshipService = new LocalLookupService("relationship");
export const permissionService = new LocalLookupService("permission");
export const disclosureConsentService = new LocalLookupService("disclosureConsent");
export const centreNumberTypeService = new LocalLookupService("centreNumberType");
export const slaService = new LocalLookupService("slas");
export const commsEnabledService = new LocalLookupService("commsEnabled");
export const editReasonService = new LocalLookupService("editReason");
export const gqVtqService = new LocalLookupService("GqVtq", true);
export const slaReasonService = new LocalLookupService("slaReason");
export const qualificationReferencesServiceSearch = new QualificationReferencesServiceSearch(API_ROOT_SEARCH, userAuthService);
export const qualificationReferencesService = new QualificationReferencesService(API_ROOT_REFDATA, userAuthService);
export const qualificationTypesService = new QualificationTypesService(API_ROOT_REFDATA, userAuthService);
export const riskTypesService = new RiskTypesService(API_ROOT_REFDATA, userAuthService);
export const generalConditionsService = new GeneralConditionsService(API_ROOT_REFDATA, userAuthService);
export const examSeriesService = new ExamSeriesService(API_ROOT_REFDATA, userAuthService);
export const examSeriesYearsService = new ExamSeriesYearsService(API_ROOT_REFDATA, userAuthService);
export const qualificationConditionsService = new QualificationConditionsService(API_ROOT_REFDATA, userAuthService);
export const subjectConditionsService = new SubjectConditionsService(API_ROOT_REFDATA, userAuthService);
export const awardingOrganisationsServiceSearch = new AwardingOrganisationsServiceSearch(API_ROOT_SEARCH, userAuthService);
export const awardingOrganisationsService = new AwardingOrganisationsService(API_ROOT_ORGS, userAuthService);
export const casesService = new CasesService(API_ROOT, userAuthService);
export const activitiesService = new ActivitiesService(API_ROOT, userAuthService);
export const rolesService = new RolesService(API_ROOT, userAuthService);
export const usersService = new UsersService(API_ROOT_USERS, userAuthService);
export const usersCachingService = CachingService(new UsersService(API_ROOT_USERS, userAuthService));
export const teamsService = new TeamsService(API_ROOT_USERS, userAuthService);
export const teamsCachingService = CachingService(new TeamsService(API_ROOT_USERS, userAuthService));
export const emailService = new EmailService(API_ROOT_USERS, userAuthService);
export const exceptionalCircumstanceService = new ExceptionalCircumstanceService(API_ROOT_REFDATA, userAuthService);
export const tagsService = new TagsService(API_ROOT_REFDATA);
export const resourceTagsService = new ResourceTagsService(API_ROOT_SVR, userAuthService);
